import React, { useEffect, useState } from "react";

import { Box, Typography, IconButton, TextField, TableBody, TableRow, TableCell } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reduxStore.ts";
import { ProductData } from "../services/product/types.ts";
import ProductCounter from "./ProductCounter.tsx";

type IProps = {
  onPress: () => void;
  src: string;
  product: ProductData;
  onPressAdd: () => void;
  onPressDec: () => void;
  onDelete: () => void;
  checked: boolean;
  onCheck: () => void;
};

const ProductCardHorizontal: React.FunctionComponent<IProps> = ({
  onPressDec,
  src,
  product,
  onPressAdd,
  onDelete,
}) => {
  const cartData = useSelector((state: StoreState) => state.cart);
  const [quantity, setQuantity] = useState<number>(0);

  useEffect(() => {
    const index = cartData.cartProducts.findIndex(
      (item) => item.productData.id === product.id
    );
    if (index > -1) {
      setQuantity(cartData.cartProducts[index].quantity);
    }
  }, [cartData.cartProducts, product.id]);

  const styles = {

    productImage: {
      width: { xs: 60, sm: 80 },
      height: { xs: 60, sm: 80 },
      borderRadius: 1,
      objectFit: "cover",
    },
    productName: {
      fontWeight: "bold",
      fontFamily: "'Spectral', serif",
      fontSize: { xs: 14, sm: 16 },
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    productDescription: {
      fontFamily: "'Spectral', serif",
      color: "rgba(0, 0, 0, 0.5)",
      display: { xs: "none", sm: "block" },
    },
    productPrice: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: { xs: 12, sm: 14 },
    },
    quantityInput: {
      width: 60, 
      textAlign: "center",
    },
    totalPrice: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: { xs: 12, sm: 14 },
    },
    deleteIcon: {
      color: "#b7472a",
    },
  };

  return (

    <TableRow>
      
    

      {/* Product Image */}
      <TableCell>
        <Box sx={{display:"flex", alignItems:"center"}}>
         <Box component="img" src={src} alt={product.name} sx={styles.productImage} />

      {/* Product Name and Description */}

      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h6" sx={styles.productName}>
          {product.name}
        </Typography>
        <Typography variant="body2" sx={styles.productDescription}>
          {product.description}
        </Typography>

      </Box>
      </Box>
      </TableCell>
      {/* Product Price */}
      <TableCell>
      <Typography sx={styles.productPrice}>
        ${product.price.toFixed(2)}
      </Typography>
      </TableCell>

      {/* Quantity Selector */}

      <TableCell>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
        }}
      >

        <IconButton onClick={onPressDec} size="small">
          <RemoveIcon />
        </IconButton>
        <TextField
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
          sx={styles.quantityInput}
          inputProps={{
            min: 1,
            style: { textAlign: "center", }, // Ensure the number is centered
          }}
        />
        <IconButton onClick={onPressAdd} size="small">
          <AddIcon />
        </IconButton>

      </Box>
      </TableCell>


      {/* Total Price */}
      <TableCell>
      <Typography sx={styles.totalPrice}>
        ${(product.price * quantity).toFixed(2)}
      </Typography>
      </TableCell>

      {/* Delete Button */}
      <TableCell>
      <IconButton onClick={onDelete} sx={styles.deleteIcon}>
        <DeleteIcon />
      </IconButton>
    </TableCell>
      
    
    </TableRow>
  
  );
};

export default ProductCardHorizontal;
